import reducer from "./reducers";
import * as actions from "./actions";
import * as types from "./types";

export const appActions = actions;
export const appReducer = reducer;
export const appTypes = types;
